import { useToast } from "vue-toastification";
import { CommonNotificationToasts } from "#components";

export const useToaster = () => {
  const toast = useToast();
  const { t } = useI18n();

  const toaster = (
    type: string,
    error: string = "default",
    variables: { [key: string]: string } = {},
    customCopy?: {
      title: string;
      message: string;
      linkUrl?: string;
      linkLabel?: string;
    }
  ) => {
    const title = customCopy?.title || t(`toastMessages.${error}.title`, variables);
    const message =
      customCopy?.message || t(`toastMessages.${error}.message`, variables);

    toast({
      component: CommonNotificationToasts,
      props: {
        type: type,
        title: title,
        message: message,
        linkUrl: customCopy?.linkUrl,
        linkLabel: customCopy?.linkLabel,
        altText: t(`main.imageAltTexts.${type}`),
      },
    });
  };

  const clearToasts = () => {
    toast.clear();
  };

  return {
    toaster,
    clearToasts,
  };
};
